import { useCallback, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import ResponsivePage from "../../common/core/ResponsivePage";
import config from "../../../config";
import DesktopDispatchView from "./views/DesktopDispatchView";
import { useDevice } from "../../../providers/DeviceProvider";
import MobileDispatchView from "./views/MobileDispatchView";
import { AddMissionFab } from "../../../hooks/useAddMissionFab";
import { DispatchProvider } from "./providers/DispatchProvider";
import { Restore as RestoreIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles()(
  () => ({
    noBackground: {
      background: "none",
      overflow: "visible !important",
    }
  })
);

export default function DispatchPage() {
  const { slim } = useDevice();
  return (
    <DispatchProvider useMissionTypeFilter={slim}>
      <DispatchLayout slim={slim} />
    </DispatchProvider>
  );
}

export function DispatchLayout(props) {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { slim } = props;

  return (
    <ResponsivePage
      title={t("dispatch:title")}
      maxWidth={config.pageSize.full}
      className={slim ? classes.noBackground : undefined}
      widget={slim ? (
        <NavLink to="completed">
          <IconButton>
            <RestoreIcon />
          </IconButton>
        </NavLink>
      ) : null}
    >

      <AddMissionFab />

      {
        slim ? (
          <MobileDispatchView />
        ) : (
          <DesktopDispatchView />
        )
      }

    </ResponsivePage>
  );
}